// Module Import
//---------------------------------
import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

// Component Import
//---------------------------------
import LinkAtom from '../../atoms/links/links'
import TypographyAtom from '../../atoms/typography/typography'
import { brandIvory } from '../../../assets/consts/color'

// Styled Component Declarations
//---------------------------------
const CalloutCTAWrapper = styled.div`
  align-self: stretch;
  display: flex;
  flex-direction: column;
  gap: 8px;
`

const CopyWrapper = styled.div`
  align-self: stretch;
  background: ${brandIvory};
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 40px 40px 60px 40px;

  h4 {
    margin: 0;
  }

  p:last-of-type {
    margin: 0;
  }
`

// Component Export
//---------------------------------
export default function CalloutCta({
  title,
  body,
  linkType,
  linkUrl,
  buttonCopy,
  onClick = () => {},
}) {
  return (
    <CalloutCTAWrapper>
      <CopyWrapper>
        <TypographyAtom type="H4" copy={title} weight="Bold" />
        <TypographyAtom type="BlockText" copyBlock={body} weight="BlockText" />
      </CopyWrapper>
      <div onClick={onClick}>
        <LinkAtom
          linkType="Primary Large CTA"
          linkText={buttonCopy}
          target={linkType}
          linkDestination={linkUrl || '#'}
        />
      </div>
    </CalloutCTAWrapper>
  )
}

CalloutCta.propTypes = {
  title: PropTypes.string.isRequired,
  body: PropTypes.PropTypes.shape({}).isRequired,
  buttonCopy: PropTypes.string.isRequired,
  linkUrl: PropTypes.string,
  linkType: PropTypes.string,
}
